<button (click)="onStart()">Start</button>&nbsp;<button (click)="onClick()">Push</button>
